<script>
import BasicInfo from '@views/NotificationAgentAdmin/form/basic-info.vue'
import DeliveryPeriod from '@views/NotificationAgentAdmin/form/delivery-period.vue'
import DeliveryTarget from '@views/NotificationAgentAdmin/form/delivery-target.vue'
import Preview from '@views/NotificationAgentAdmin/form/preview.vue'
import {
  notificationComputed,
  notificationMethods,
} from '@state/helpers/notification'
import {
  agentDetailsComputed,
  agentDetailsMethods,
} from '@state/helpers/agent-details'
import { cloneDeep } from 'lodash'
import store from '@state/store'

export default {
  page: {
    title: 'Notification Agent Admin Add New',
    meta: [
      {
        name: 'description',
        content: 'The Notification Agent Admin Add New page.',
      },
    ],
  },
  components: {
    BasicInfo,
    DeliveryPeriod,
    DeliveryTarget,
    Preview,
  },
  data() {
    return {
      currentUser: store.getters['auth/getCurrentUser'],
      notificationDetail: {},
      previewErrors: {},
      period: {},
      target: {},
      delivered: '0',
      previewed: false,
      openConfirm: false,
    }
  },
  computed: {
    ...notificationComputed,
    ...agentDetailsComputed,
    previewComputed() {
      return !this.previewed
    },
  },
  watch: {
    previewErrors() {
      if (this.previewErrors) {
        this.$refs.observer.setErrors(this.previewErrors)
      }
    },
  },
  async created() {
    const response = await this.getDetailsById({
      id: this.currentUser?.agent.id,
    })
    if (response) {
      this.notificationDetail.company = response.company || ''
    }
    this.$router
      .replace({
        query: { agent_code: this.currentUser?.agent?.agent_code },
      })
      // eslint-disable-next-line handle-callback-err
      .catch((error) => {})
  },
  methods: {
    ...notificationMethods,
    ...agentDetailsMethods,
    handlePreview(pre) {
      this.previewed = pre
    },
    handleValidatePreview(error) {
      this.previewErrors = error
    },
    async handleApply(quote) {
      const response = await this.fetchingNotificationById({ id: quote })
      const scheduleStart = this.notificationDetail.schedule_start
      const scheduleEnd = this.notificationDetail.schedule_end
      const notificationDetail = response ? cloneDeep(response) : {}
      this.notificationDetail = {
        ...notificationDetail,
        ...{
          quote: quote,
          schedule_start: scheduleStart,
          schedule_end: scheduleEnd,
        },
      }
    },
    changeBasicInfo(notificationDetail) {
      this.notificationDetail = {
        ...this.notificationDetail,
        ...notificationDetail,
      }
    },
    changeDeliveryPeriod(notificationDetail) {
      this.notificationDetail = {
        ...this.notificationDetail,
        ...notificationDetail,
      }
    },
    changeDeliveryTarget(notificationDetail) {
      this.notificationDetail = {
        ...this.notificationDetail,
        ...notificationDetail,
      }
    },
    async handleRegisterNotification() {
      const notificationDetail = { ...this.notificationDetail }
      if (!notificationDetail.order) {
        notificationDetail.order = 99
      }
      if (notificationDetail.image_binary) {
        const imageBinary = notificationDetail.image_binary
        notificationDetail.image_binary = imageBinary.includes(',')
          ? imageBinary.split(',')[1]
          : ''
      }
      if (notificationDetail.filter_obj) {
        const keys = [
          'age_range_lower',
          'age_range_upper',
          'weight_differ_lower',
          'weight_differ_upper',
          'body_fat_rate_differ_lower',
          'body_fat_rate_differ_upper',
        ]
        const filterObj = notificationDetail.filter_obj
        for (const key of keys) {
          if (!filterObj[key] && filterObj[key] !== 0) {
            filterObj[key] = -9999
          }
        }
        notificationDetail.filter_obj = filterObj
      } else {
        notificationDetail.filter_obj = null
      }

      const response = await this.registerNotification({
        ...notificationDetail,
        ...{
          agent_id: this.currentUser?.agent.id,
          place: 1,
          created_admin_id: this.currentUser?.id,
        },
      })
      if (response && typeof response === 'object') {
        await this.$router.push({ name: 'notificationAgentAdmin' })
      }
    },
    showConfirm() {
      this.openConfirm = true
    },
  },
}
</script>

<template>
  <div id="notification-registration">
    <validation-observer ref="observer" v-slot="{ handleSubmit, failed }">
      <CForm
        class="position-relative"
        @submit.stop.prevent="handleSubmit(showConfirm)"
      >
        <CRow>
          <CCol sm="6">
            <BasicInfo
              :notification-detail="notificationDetail"
              :errors="previewErrors"
              @onClickQuote="handleApply"
              @change="changeBasicInfo"
            />
            <DeliveryPeriod
              :notification-detail="notificationDetail"
              :errors="previewErrors"
              @change="changeDeliveryPeriod"
            />
            <DeliveryTarget
              :notification-detail="notificationDetail"
              :errors="previewErrors"
              @change="changeDeliveryTarget"
            />
          </CCol>
          <CCol sm="6">
            <Preview
              :notification-detail="notificationDetail"
              :failed="failed"
              @preview-update="handlePreview"
              @validate="handleValidatePreview"
            />
            <div class="d-flex justify-content-end">
              <CButton
                color="primary"
                type="submit"
                :disabled="previewComputed"
              >
                {{ $t('confirm.add.btn') }}
              </CButton>
              <CButton
                type="button"
                color="dark"
                class="ml-2"
                variant="outline"
                @click="$router.push({ name: 'notificationAgentAdmin' })"
              >
                {{ $t('common.cancel') }}
              </CButton>
            </div>
          </CCol>
        </CRow>
      </CForm>
      <BaseModalConfirm
        type="add"
        :show.sync="openConfirm"
        @closeModal="openConfirm = !openConfirm"
        @submit="handleRegisterNotification"
      />
    </validation-observer>
  </div>
</template>
